/* @ngInject */
function formatsService (CONSTANTS, Utils, ConnectorWebService) {
  const service = {
    getFormats,
    deleteFormat,
    createFormat,
    getFormatById,
    getMostUsedFormats,
    getFormatsSuggestions
  }

  return service

  function getFormats (params) {
    const { top, skip, search } = params

    let url = CONSTANTS.URL_FORMATS

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if (search) {
      url = Utils.fnAddQueryToUrl(url, {
        search
      })
    }

    return ConnectorWebService.get(url)
  }

  function getMostUsedFormats (params) {
    const { top, skip } = params
    let url = CONSTANTS.URL_FORMATS_MOST_USED

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    return ConnectorWebService.get(url)
  }

  function getFormatById (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_FORMATS_ID, [id])

    return ConnectorWebService.get(url)
  }

  function deleteFormat (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_FORMATS_ID, [id])

    return ConnectorWebService.fnDelete(url)
  }

  function createFormat (format) {
    const url = CONSTANTS.URL_FORMATS

    return ConnectorWebService.post(url, format)
  }

  function getFormatsSuggestions (params) {
    const { width, height, unit } = params

    let url = CONSTANTS.URL_PRODUCTS_SUGGESTIONS

    if (width) {
      url = Utils.fnAddQueryToUrl(url, {
        width
      })
    }

    if (height) {
      url = Utils.fnAddQueryToUrl(url, {
        height
      })
    }

    if (unit) {
      url = Utils.fnAddQueryToUrl(url, {
        unit
      })
    }

    return ConnectorWebService.get(url)
  }
}

export { formatsService }
